<script setup lang="ts">
import { Check, TriangleAlert, X } from 'lucide-vue-next'
import type { ChecklistStatus } from '@ck/domain'

defineProps<{ modelValue: ChecklistStatus }>()
const emit = defineEmits<{ 'update:modelValue': [status: ChecklistStatus] }>()
</script>

<template>
  <div class="ck-segmented" role="group" aria-label="Status do item">
    <button type="button" class="ck-segmented-btn ck-segmented-btn--ok" :class="{ selected: modelValue === 'ok' }" :aria-pressed="modelValue === 'ok'" @click="emit('update:modelValue', 'ok')"><Check :size="16" />OK</button>
    <button type="button" class="ck-segmented-btn ck-segmented-btn--attention" :class="{ selected: modelValue === 'attention' }" :aria-pressed="modelValue === 'attention'" @click="emit('update:modelValue', 'attention')"><TriangleAlert :size="16" />Atenção</button>
    <button type="button" class="ck-segmented-btn ck-segmented-btn--rejected" :class="{ selected: modelValue === 'rejected' }" :aria-pressed="modelValue === 'rejected'" @click="emit('update:modelValue', 'rejected')"><X :size="16" />Reprovado</button>
  </div>
</template>

<style scoped>
.ck-segmented { display: grid; grid-template-columns: repeat(3, 1fr); gap: 5px; }
.ck-segmented-btn { display: flex; align-items: center; justify-content: center; gap: 4px; min-height: 38px; padding: 5px; border: 1px solid var(--ck-cream-300); border-radius: var(--radius-sm); background: var(--ck-cream-100); color: inherit; font-size: 11px; font-weight: var(--fw-semibold); transition: background 160ms ease-out, border-color 160ms ease-out, color 160ms ease-out; cursor: pointer; }
.ck-segmented-btn--ok.selected { background: var(--ck-ok-500); border-color: var(--ck-ok-500); color: white; }
.ck-segmented-btn--attention.selected { background: var(--ck-warn-500); border-color: var(--ck-warn-500); color: white; }
.ck-segmented-btn--rejected.selected { background: var(--ck-fail-500); border-color: var(--ck-fail-500); color: white; }
@media (prefers-reduced-motion: reduce) { .ck-segmented-btn { transition: none; } }
</style>
